import React from 'react'
import { useEffect } from "react";
import AOS from 'aos';


const AosAnimtion = () => {
    useEffect(() => {
        AOS.init({ duration: 1000 }); // Initialize AOS
    }, []);


    return (
        <>
            <div></div>
        </>


    )
}

export default AosAnimtion